<script>
    // какой ты персонаж
    
    export let wrapper;
    export let data;
    export let reward;
    const check = () => {
        let match = {}, min = 0;
        
        document.querySelectorAll('[data-question] input[type="checkbox"]:checked').forEach((inp) => {
            data.options.forEach((item, i) => {
                if (
                    (
                        item.match.includes(inp.value) &&
                        params && +params.type === 1
                    ) || (
                        item.match === inp.value &&
                        params && +params.type === 2
                    )
                ) {
                    match[item.character] = match[item.character] ? match[item.character] : {t: item.character, b: 0};
                    match[item.character]['b']++;
                    
                    if (match[item.character]['b'] > min) {
                        min = match[item.character]['b'];
                    }
                }
            })
        });
        characters = Object.keys(match).filter(key => match[key]['b'] >= min);

        if (params && params.type === '2') {
            reward(characters.join(', '));
        } else {
            switch (characters.length) {
                case 1: {
                    reward(characters[0]);
                    break;
                }
                default: {
                    (new bootstrap.Modal(document.getElementById('event-select-character'))).show();
                }
            }
        }
    }

    let params = Array.isArray(data.params) ? data.params[0] : data.params;
    let characters = [];
    
    let items = data.options
        .map(o => o.match.split(';').map(s => s.trim()))
        .flat(1)
        .filter((v, i, a) => a.indexOf(v) === i)
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
</script>


<div class="card" data-question>
    <div class="card-body">
        <h5 class="card-title text-md-center m-0">Выберите варианты которые вам подходят</h5>
    
        <div class="row mt-3">
            {#each items as item}
                <div class="col-12 col-sm-6 py-1 py-sm-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="{item}" value="{item}">
                        <label class="form-check-label" for="{item}">{item}</label>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>

<div class="row mt-3">
    <div class="col-12">
        <button type="button" class="btn btn-primary btn-block btn-lg" on:click={check}>Готово</button>
    </div>
</div>

<!-- Dialog Event Select Character -->
<div class="modal fade dialogbox" id="event-select-character" data-bs-backdrop="static" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Выберете один результат</h5>
            </div>
            <div class="modal-body mb-2">
                <div class="row">
                    {#each characters as character}
                        <div class="col-12">
                            <button type="button" class="btn btn-outline-secondary w-100 my-1" data-bs-dismiss="modal" on:click={() => reward(character)}>{character}</button>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>
<!-- * Dialog Event Select Character -->
